"use strict";
(self["webpackChunkdev"] = self["webpackChunkdev"] || []).push([[542,7713,1592,6466],{

/***/ 7713:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ headerScroll)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _on_sight_dev_tools_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4635);
// components/headerScroll.js




function headerScroll(node) {
  const selectors = {
    activeClass: "on",
    headerWrapper: ".js-fixed-header"
  }

  let settings = {
    yThreshold: 100
  }

  let cache = {
    $headerWrapper: jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.headerWrapper)
  }

  const handleHeaderStickiness = function (e) {
    cache.$headerWrapper.toggleClass('on', (window.scrollY > settings.yThreshold))
  }

  const init = function () {
    if ((0,_on_sight_dev_tools_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)([cache.$headerWrapper])) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('scroll', handleHeaderStickiness);
    }
  }

  init()
}


/***/ }),

/***/ 542:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Menu)
/* harmony export */ });
/* harmony import */ var _megaMenu_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1592);
/* harmony import */ var _headerScroll_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7713);
// components/menu.js [aa]



function Menu({ wrapper }) {
  const selectors = {
    megaMenuTrigger: "[data-mega-trigger]",
    megaMenuClose: "[data-menu-close]",
    mobileMenuTrigger: "[data-mobile-trigger]",
    megaMenuSublink: "[data-menu-sublink]",
    megaMenuImage: "[data-menu-image]",
    megaMenuContainer: "[data-mega-region]",
    mobileNav: "[data-mobile-nav]",
    mainNav: "[data-main-nav]",
    activeClass: "on",
    openClass: "open",
    headerWrapper: ".js-fixed-header",
  };

  let settings = {
    yThreshold: 50,
  };

  (0,_megaMenu_js__WEBPACK_IMPORTED_MODULE_0__["default"])(selectors, settings);
  (0,_headerScroll_js__WEBPACK_IMPORTED_MODULE_1__["default"])(selectors.headerWrapper, settings);
};


/***/ }),

/***/ 1592:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _on_sight_dev_tools_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4635);
/* harmony import */ var _utilities_functions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6466);




const MegaMenu = function (selectors, settings) {
  if (!(0,_on_sight_dev_tools_utils__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)([selectors.megaMenuTrigger])) return;

  let activeMenu = {};

  const init = function () {
    initializeMobileMenuHeight();

    // Mobile Menu Trigger Events
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.mobileMenuTrigger).on("click", toggleMegaMenu);

    // Open + Close mega menu
    // Click to toggle
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.megaMenuTrigger).on("click", toggleMegaMenu);

    // Overlay Events
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('popup:close', closeMegaMenu);
  };

  const initializeMobileMenuHeight = function () {
    if (screen.availWidth < parseInt(config.screens.xl)) {
      let $headerWrapper = jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.headerWrapper);
      let $mobileNav = jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.mobileNav);

      let headerHeight = $headerWrapper.height();

      $mobileNav.css("--top", `${headerHeight}px`);
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.megaMenuContainer).css("--top", `${headerHeight}px`);
    }
  };

  const setActiveMenu = function (menuTitle, level) {
    if (menuTitle) {
      activeMenu[level] = menuTitle;
    } else if (level) {
      delete activeMenu[level];
    } else {
      activeMenu = {};
    }
  };

  // AA: Click event tied to mega menu links
  const toggleMegaMenu = function (e) {
    e.preventDefault();

    let $this = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this);
    let activeLink = $this.data("megaMenu");
    let $activeMegaMenu = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`${selectors.megaMenuContainer}[data-mega-menu="${activeLink}"]`);
    let level = $this.data("level");

    if (activeMenu[level]) {
      let menuShouldTransition = activeMenu[level] === activeLink;
      // menu is open. Close the active menu and open the new active one.

      closeMegaMenu(menuShouldTransition, level);


      if (!menuShouldTransition) {
        openMegaMenu($activeMegaMenu, $this, level, menuShouldTransition);
      }
    } else {
      // no menus open. Open the menu with slide out transition
      openMegaMenu($activeMegaMenu, $this, level);
    }
  }

  const openMegaMenu = function ($activeMegaMenu, $activeLink, level) {
    // Opens the menu without a slide down transition
    const activeHandle = $activeMegaMenu.data("megaMenu")
    const $link = jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.megaMenuTrigger).filter(`[data-mega-menu="${activeHandle}"]`)
    const $mLink = jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.mobileMenuTrigger).filter(`[data-mega-menu="${activeHandle}"]`)
    const $links = $link.add($mLink)

    $activeMegaMenu.addClass(selectors.activeClass)
    $links.addClass(selectors.activeClass)
    $links.attr('aria-expanded', true)

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.headerWrapper).addClass(selectors.openClass);
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.mainNav).addClass(selectors.activeClass);

    setActiveMenu($activeLink.data("megaMenu"), level);
    (0,_utilities_functions__WEBPACK_IMPORTED_MODULE_1__.disableScroll)();

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger("overlay:show")
  }

  const handleMenuClose = function ($menu, $links) {
    $menu.removeClass(selectors.activeClass)
    $links.attr('aria-expanded', false)
  }

  const handleCloseCleanUp = function ($menus) {
    if (!Object.keys(activeMenu).length) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.megaMenuTrigger).removeClass(selectors.activeClass);
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.mobileMenuTrigger).removeClass(selectors.activeClass);

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.mainNav).removeClass(selectors.activeClass);
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.headerWrapper).removeClass(selectors.openClass);

      (0,_utilities_functions__WEBPACK_IMPORTED_MODULE_1__.enableScroll)();
    }
  };

  const closeMegaMenu = function (transition = false, level = 1) {
    // Closes the menu with specified transition

    const activeLink = activeMenu[level]

    const $currentlyActiveMenu = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`${selectors.megaMenuContainer}[data-mega-menu="${activeLink}"]`)
    const $link = jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.megaMenuTrigger).filter(`[data-mega-menu="${activeLink}"]`)
    const $mLink = jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.mobileMenuTrigger).filter(`[data-mega-menu="${activeLink}"]`)

    const $links = $link.add($mLink)
    const $allOpenMenus = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`${selectors.megaMenuContainer}.${selectors.activeClass}`)
    const $allOpenLinks = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`${selectors.megaMenuTrigger}.${selectors.activeClass}, ${selectors.mobileMenuTrigger}.${selectors.activeClass}`)

    if (level === 1) {
      // If level === "1" close everything
      handleMenuClose($allOpenMenus, $allOpenLinks.add($links))
      setActiveMenu(undefined, undefined)
      handleCloseCleanUp($allOpenMenus)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger("overlay:hide")
    } else {
      // If level === "2" close secondary level only
      handleMenuClose($currentlyActiveMenu, $links)
      setActiveMenu(undefined, level)
      handleCloseCleanUp($currentlyActiveMenu);
    }
  }

  init();
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MegaMenu);


/***/ }),

/***/ 6466:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   disableScroll: () => (/* binding */ disableScroll),
/* harmony export */   enableScroll: () => (/* binding */ enableScroll),
/* harmony export */   formatMoney: () => (/* binding */ formatMoney),
/* harmony export */   isMobile: () => (/* binding */ isMobile),
/* harmony export */   syncElementsHeight: () => (/* binding */ syncElementsHeight),
/* harmony export */   toggleScroll: () => (/* binding */ toggleScroll)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function toggleScroll() {
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.body).toggleClass('overflow-hidden');
}

function enableScroll() {
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.body).removeClass('overflow-hidden');
}

function disableScroll() {
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.body).addClass('overflow-hidden');
}

/**
 * * Determines if the current screen is mobile-sized
 *
 * @returns {boolean} Whether the current screen width is within the mobile threshhold
 */
function isMobile() {
  return window.screen.availWidth < parseInt(window.config.screens.md);
}

/**
 *
 * @param {*} cents
 * @param {*} format
 * @returns
 */
function formatMoney(cents, format) {
  if (typeof cents == 'string') cents = cents.replace('.', '');

  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || '${{ amount }}');

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;

    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;

    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;

    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;

  }

  return formatString.replace(placeholderRegex, value);
};


/**
 * Updates a list of elements to all match the height of the tallest element provided
 * 
 * @param {jQuery node list} $elements 
 */
function syncElementsHeight($elements) {
  if (!$elements.length) return;

  // Reset heights to get accurate measurement
  $elements.height('auto');

  // Sort elements by intrinsic height
  const sortedByHeight = $elements.sort((a, b) => {
    return b.offsetHeight - a.offsetHeight;;
  });
  const maxHeight = sortedByHeight[0].offsetHeight;

  // Set all elements to match the tallest element found
  $elements.height(maxHeight);
}


/***/ })

}]);